import { Stack } from 'expo-router';

// The default React Navigation header this Stack.Screen used to show
// (headerShown: true, title: 'Sign up') rendered directly above
// sign-up's own in-body "Sign up"/"One last thing" heading -- the same
// text, twice, in two different typefaces (whole-app critique
// 2026-09-02). headerShown: false here matches the root _layout.tsx's
// own screenOptions pattern for the same reason. The header used to
// carry this modal's only dismiss action too (native gets
// swipe-to-dismiss on iOS/Android, but there's no equivalent gesture on
// web) -- that control now lives in-body, in
// src/screens/sign-up/index.tsx, so removing the header doesn't strip
// it.
export default function UnauthLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="sign-up" options={{ presentation: 'modal' }} />
    </Stack>
  );
}
